import { clone } from './clone';

export const moveListItem = <T>(list: T[], source: number, destination: number): T[] => {
  const s = clone(list[source]);
  const newList = list.filter((_, i) => i !== source);
  return [...newList.slice(0, destination), s, ...newList.slice(destination)];
};
